/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum MedicalActionGroupLimitScope {
    FT_TICKET = 'FT_TICKET',
    PATIENT_PERIOD = 'PATIENT_PERIOD',
}
